import { TypedUseMutationResult } from '@reduxjs/toolkit/query/react';
import { toast, ToastOptions } from 'react-toastify';
import { Error, ErrorMapper } from './Alerts.tsx';

export function toastError(
    {
        api,
        message,
        errorMapper,
        options
    } : {
        // eslint-disable-next-line
        api: TypedUseMutationResult<unknown, unknown, any>,
        message: string,
        errorMapper? : ErrorMapper,
        options?: ToastOptions
    }
    ) {
    toast.error(<Error api={api} failMessage={message} errorMapper={errorMapper}/>, options);
}
